import { AdminUser } from 'lib/types';
import { createContext } from 'react';

export type AuthState = 'IDLE' | 'AUTHENTICATED' | 'UNAUTHENTICATED';

export type AuthContextValue = {
  authState: AuthState;
  accessToken: string | null;
  profile: AdminUser | undefined;
  login: (args: { username: string; password: string }) => Promise<void>;
  logout: () => void;
  isLoading: boolean;
};

export const AuthContext = createContext<AuthContextValue>({} as AuthContextValue);
